export default __webpack_public_path__ + "a13a8fc8540aa5c014dbb574a194f09c.webp";